const GOOGLE_API_KEY="AIzaSyAOLRwLjng_ppCdMw4-tuH3VgF2FGqZlxg";
export const YOUTUBE_VIDEOS_API="https://youtube.googleapis.com/youtube/v3/videos?key="+GOOGLE_API_KEY;
export const WETUBE_API=`https://www.googleapis.com/youtube/v3/videos?part=snippet&chart=mostPopular&maxResults=50&key=${GOOGLE_API_KEY}`;

